import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { NotificationBannerItem } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { useLocalizedBillingStatus } from "../../../setting/billing/payment-methods/localized-billing";
import { ActionRequiredSeverity } from "./action-required-severity";

export function useLocalizedBillingNotification(): {
  severity: ActionRequiredSeverity;
  item: NotificationBannerItem;
} | null {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const canEditSettings = useHasPermission(
    SettingsPermissions.SET_BILLING_SETTINGS,
  );
  const { data: status } = useLocalizedBillingStatus({
    enabled: canEditSettings,
  });

  if (!canEditSettings || !status?.available || status.paymentMethod) {
    return null;
  }

  return {
    severity: ActionRequiredSeverity.Low,
    item: {
      id: "localized-billing",
      type: "info",
      message: t(
        "You can now be billed in {{currency}} by Redo's local entity. Add a card in billing settings to switch your {{currency}} charges.",
        { currency: status.currency },
      ),
      actions: [
        {
          actionType: "link",
          internal: true,
          target: "_self",
          text: t("Add card"),
          href: routes.getSettingsSubRoute("billing"),
        },
      ],
    },
  };
}
